import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import { Col } from 'js/components/Grid'
import PollViewForm from 'js/page/Widget/components/Poll/PollViewForm'

import Accordeon from '../../components/Accordeon'

const Poll = () => {
    const { data } = useQuery<any>(GET_POLL)

    if (!data?.entities || data.entities.edges.length === 0) {
        return null
    }

    return (
        <Col
            mobileLandscape={1 / 2}
            tablet={1 / 2}
            className="ActivityStreamPoll"
        >
            <Accordeon title={data.entities.edges[0].title}>
                <PollViewForm
                    viewer={data.viewer}
                    entity={data.entities.edges[0]}
                    size="small"
                    legend={data.entities.edges[0].title}
                />
            </Accordeon>
        </Col>
    )
}

export default Poll

const GET_POLL = gql`
    query GetPoll {
        viewer {
            guid
            loggedIn
        }
        entities(subtype: "poll", limit: 1) {
            total
            edges {
                guid
                ... on Poll {
                    title
                    url
                    canEdit
                    hasVoted
                    canVote
                    voteWithoutAccount
                    choices {
                        guid
                        text
                        votes
                    }
                }
            }
        }
    }
`
